var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "oauth-wrapper" }, [
    _c("div", { staticClass: "oauth" }, [
      _c("div", { staticClass: "oauth-avatar" }, [
        _c("i", { staticClass: "oauth-avatar__icon" }, [
          _c("img", { attrs: { src: _vm.appInfo.appLogoUrl, alt: "" } }),
        ]),
        _c(
          "i",
          { staticClass: "oauth-avatar__arrow" },
          [_c("icon-font", { attrs: { type: "gb-icon-shouquan" } })],
          1
        ),
        _vm._m(0),
        _c("b", [
          _vm._v(_vm._s(_vm.appInfo.appName) + "请求登录你的ECCANG账号"),
        ]),
      ]),
      _c("div", { staticClass: "oauth-compony" }, [
        _c("div", { staticClass: "oauth-subtitle" }, [
          _vm._v("你将以该身份登录"),
        ]),
        !_vm.authenticationCode
          ? _c("div", { staticClass: "oauth-compony-item" }, [
              _vm._m(1),
              _c("div", { staticClass: "oauth-compony-item__content" }, [
                _c("b", [
                  _vm._v(_vm._s(_vm.userInfo.onlineSubjectName || "个人企业")),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.userInfo.realName ||
                        _vm.userInfo.phone ||
                        _vm.userInfo.userName
                    )
                  ),
                ]),
              ]),
            ])
          : _c(
              "div",
              { staticClass: "oauth-compony-radio-warpper" },
              _vm._l(_vm.subjectDTOS, function (item) {
                return _c(
                  "div",
                  { key: item.subjectId, staticClass: "oauth-compony-item" },
                  [
                    _c("a", {
                      class: { checked: item.subjectId === _vm.subjectId },
                      attrs: { href: "javascript:void(0);" },
                      on: {
                        click: function ($event) {
                          _vm.subjectId = item.subjectId
                        },
                      },
                    }),
                    _vm._m(2, true),
                    _c("div", { staticClass: "oauth-compony-item__content" }, [
                      _c("b", [_vm._v(_vm._s(item.companyName))]),
                      _c("span", [_vm._v(_vm._s(item.userName))]),
                    ]),
                  ]
                )
              }),
              0
            ),
      ]),
      _vm._m(3),
    ]),
    _vm.appInfo.appId
      ? _c(
          "div",
          { staticClass: "btns" },
          [
            _c(
              "a-button",
              { attrs: { type: "default" }, on: { click: _vm.refuse } },
              [_vm._v("拒绝")]
            ),
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.loading },
                on: { click: _vm.toAuth },
              },
              [_vm._v("授权")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("i", { staticClass: "oauth-avatar__icon" }, [
      _c("img", { attrs: { src: require("@/assets/blogo.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("i", [
      _c("img", { attrs: { src: require("@/assets/171559.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("i", [
      _c("img", { attrs: { src: require("@/assets/171559.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "oauth-info" }, [
      _c("div", { staticClass: "oauth-subtitle" }, [_vm._v("将获取以下权限")]),
      _c("div", { staticClass: "oauth-info__item" }, [
        _c("p", [_vm._v("获取你的姓名，头像")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }